/********** 12Tshirts**********/
  /***** adobefont *****/
    (function(d) {
      var config = {
        kitId: 'wqa4aqs',
        scriptTimeout: 3000,
        async: true
      },
      h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
    })(document);
  /***** /adobefont *****/

  /***** a no link *****/
    $(function(){
        $('a.nolink').on('click', function() {
          return false;
        });
    });
  /***** /a no link *****/

  /***** hero *****/
    jQuery(function(){
      $(".thum img").click(function(){
        url = $(this).attr('src');
        id = $(this).parents('ul').attr('id');
        $('#' + id + " .mainImg img").attr('src', url).css({'display': 'none'}).fadeIn(1000);
      });
    });

    jQuery(function(){
      $(".thum img").one("click", function() {
        $('.mainImg > figure > a').zoom();
        $('.mainImg > figure').zoom();
      });
    });

    jQuery(function(){
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("section#hero > figure:first-child").hide().fadeIn(1000).delay(100).animate({ top:'-1%' }, 700, 'swing');
      } else {
        $("section#hero > figure:first-child").hide().fadeIn(1000).delay(100).animate({ top:'-1.1%' }, 700, 'swing');
      };
    });
  /***** /hero *****/

  /***** tab *****/
    /* 毎月追加 */
    jQuery(function($){
      $('.month01.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#jan.list').removeClass('hide');
      });
      $('.month02.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#feb.list').removeClass('hide');
      });
      $('.month02.tabbtn img').css({'cursor': 'pointer'});
      $('.month03.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#mar.list').removeClass('hide');
      });
      $('.month03.tabbtn img').css({'cursor': 'pointer'});
      $('.month04.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#apr.list').removeClass('hide');
      });
      $('.month04.tabbtn img').css({'cursor': 'pointer'});
      $('.month05.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#may.list').removeClass('hide');
      });
      $('.month05.tabbtn img').css({'cursor': 'pointer'});
      $('.month06.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#jun.list').removeClass('hide');
      });
      $('.month06.tabbtn img').css({'cursor': 'pointer'});
      $('.month07.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#jul.list').removeClass('hide');
      });
      $('.month07.tabbtn img').css({'cursor': 'pointer'});
      $('.month08.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#aug.list').removeClass('hide');
      });
      $('.month08.tabbtn img').css({'cursor': 'pointer'});
      $('.month09.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#sep.list').removeClass('hide');
      });
      $('.month09.tabbtn img').css({'cursor': 'pointer'});
      $('.month10.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#oct.list').removeClass('hide');
      });
      $('.month10.tabbtn img').css({'cursor': 'pointer'});
      /* $('.month11.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#nov.list').removeClass('hide');
      });
      $('.month11.tabbtn img').css({'cursor': 'pointer'});
      $('.month12.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#dec.list').removeClass('hide');
      });
      $('.month12.tabbtn img').css({'cursor': 'pointer'}); */

      /* クラス毎月追加 */
      $('.month01.tabbtn, .month02.tabbtn, .month03.tabbtn, .month04.tabbtn, .month05.tabbtn, .month06.tabbtn, .month07.tabbtn, .month08.tabbtn, .month09.tabbtn, .month10.tabbtn').click(function(){;
        var heroW = $('#hero').outerWidth();
        // var scrollTop = main.scrollTop;
        var pos = heroW * 0.28
        var posSp = 200
        if (window.matchMedia("(max-width: 768px)").matches) {
          $('body,html').animate({
            scrollTop: posSp
          }, 300, 'swing');
          return false;
        } else {
          $('body,html').animate({
            scrollTop: pos
          }, 300, 'swing');
          return false;
        };
      });

      /* $(function () {
        var headH = $("header").outerHeight();
        var animeSpeed = 500;
        $(".tabbtn a[href^='#']").on({
          "click": function () {
            var href = $(this).attr("href");
            var target = $(href == "#" || href === "" ? "html" : href);
            var position;
            position = target.offset().top - headH;
            $("body,html").stop().animate({ scrollTop: position }, animeSpeed);
            return false;
          }
        });
      }); */


    });
  /***** /tab *****/

  /***** slick *****/
    $(document).ready(function(){
      $('ul#month').slick({
        autoplay: false,
        autoplay: true,
        autoplaySpeed: 4000,
        // centerMode: true,
        // centerPadding: '8%',
        cssEase: 'cubic-bezier(0.5,-1,0.5,2)',
        // easing: 'easeOutBounce',
        initialSlide: 0,
        slidesToShow: 3,
        speed: 1000,
        responsive: [{
          breakpoint: 812,
          settings: {
            slidesToShow:2
          }
        }]
      });
    });
  /***** /slick *****/

  /***** modal *****/
    $(function(){
      var modal = $('.slick-slide img');
      modal.on('click', function(){
        var imgPath = $(this).prop('outerHTML');
        $('#over').fadeIn(500);
        $('#modal').fadeIn(1000).html(imgPath+'<i class="fas fa-times-circle" id="close"></i>');
      });
      $('#over, #close').on('click', function(){
        $('#over').fadeOut(500);
        $('#modal').fadeOut(100);
      });
    });
  /***** /modal *****/

  /***** timer *****/
    $(document).ready(function() {
      $.ajax({
          type: 'GET',
          cache: false
        }).done(function(data, status, xhr) {
          var serverDate = new Date(xhr.getResponseHeader('Date'));
          var setStart = new Date('2024/06/06 14:25:59');

          /* if(setStart >= serverDate){
            console.log('to')
            $('.thismonth').addClass('hide');
            $('.lastmonth').removeClass('hide');
          } else {
            console.log('past')
            $('.lastmonth').addClass('hide');
            $('.thismonth').removeClass('hide');
          } */

          $(".show_timer").each(function(index, target) {
            var startDate = $(this).attr("data-startdate");
            var endDate = $(this).attr("data-enddate");
            var svDate = new Date(serverDate);
            var stDate = new Date(startDate);
            var edDate = new Date(endDate);

            if(svDate >= stDate || !stDate && svDate < edDate || svDate < edDate){
              $(this).removeClass('hide');
            }

            if(stDate < edDate){
              if(svDate < stDate){
                $(this).addClass('hide');
              } else {
                $(this).removeClass('hide');
              }
            }

            if(svDate >= edDate){
              var tgt = !$(this).hasClass('hide');
              if(tgt && (svDate < stDate || stDate < edDate || !stDate) && svDate >= edDate){
                $(this).addClass('hide');
              }
            }

          });

        }).fail(function() {
          var date = new Date();

          $(".show_timer").each(function(index, target) {
            var startDate = $(this).attr("data-startdate");
            var endDate = $(this).attr("data-enddate");
            var ctDate = new Date(date);
            var stDate = new Date(startDate);
            var edDate = new Date(endDate);

            if(ctDate >= stDate || !stDate && ctDate < edDate || ctDate < edDate){
              $(this).removeClass('hide');
            }

            if(stDate < edDate){
              if(ctDate < stDate){
                $(this).addClass('hide');
              } else {
                $(this).removeClass('hide');
              }
            }

            if(ctDate >= edDate){
              var tgt = !$(this).hasClass('hide');
              if(tgt && (ctDate < stDate || stDate < edDate || !stDate) && ctDate >= edDate){
                $(this).addClass('hide');
              }
            }

        });

      });

        
      // 毎月2か所追加
      linkjan = $('#jan > .mainImg > figure.pointer') 
      // linkjan.on( clickEventType, function(){ location.href = '/products/anxz-26290-anxz-26291-anxz-26292'; });
      linkjan.on('click', function(){ location.href = '/products/anxz-26290-anxz-26291-anxz-26292'; });
      $(function () {
        $(linkjan).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '/products/anxz-26290-anxz-26291-anxz-26292';},
          500 
        );
      });

      linkfeb = $('#feb > .mainImg > figure.pointer') 
      linkfeb.on('click', function(){ location.href = '/products/anxz-26293-anxz-26294-anxz-26295'; });
      $(function () {
        $(linkfeb).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '/products/anxz-26293-anxz-26294-anxz-26295';},
          500 
        );
      });

      linkmar = $('#mar > .mainImg > figure.pointer') 
      linkmar.on('click', function(){ location.href = '/products/anxz-26296-anxz-26297-anxz-26298'; });
      $(function () {
        $(linkmar).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '/products/anxz-26296-anxz-26297-anxz-26298';},
          500 
        );
      });


      linkapr = $('#apr > .mainImg > figure.pointer') 
      linkapr.on('click', function(){ location.href = '/products/anxz-26299-anxz-26300-anxz-26301'; });
      $(function () {
        $(linkapr).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '/products/anxz-26299-anxz-26300-anxz-26301';},
          500 
        );
      });

      linkmay = $('#may > .mainImg > figure.pointer') 
      linkmay.on('click', function(){ location.href = '/products/anxz-26302-anxz-26303-anxz-26304'; });
      $(function () {
        $(linkmay).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '/products/anxz-26302-anxz-26303-anxz-26304';},
          500 
        );
      });

      linkjun = $('#jun > .mainImg > figure.pointer') 
      linkjun.on('click', function(){ location.href = '/products/anxz-26305-anxz-26306-anxz-26307'; });
      $(function () {
        $(linkjun).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '/products/anxz-26305-anxz-26306-anxz-26307';},
          500 
        );
      });

      linkjul = $('#jul > .mainImg > figure.pointer') 
      linkjul.on('click', function(){ location.href = '/products/ryuic-a000014'; });
      $(function () {
        $(linkjul).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '/products/ryuic-a000014';},
          500 
        );
      });

      linkaug = $('#aug > .mainImg > figure.pointer') 
      linkaug.on('click', function(){ location.href = '/products/ryuic-a000015'; });
      $(function () {
        $(linkaug).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '/products/ryuic-a000015';},
          500 
        );
      });

      linksep = $('#sep > .mainImg > figure.pointer') 
      linksep.on('click', function(){ location.href = '/products/ryuic-a000016'; });
      $(function () {
        $(linksep).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '/products/ryuic-a000016';},
          500 
        );
      });

      linkoct = $('#oct > .mainImg > figure.pointer') 
      linkoct.on('click', function(){ location.href = '/products/ryuic-a000017'; });
      $(function () {
        $(linkoct).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '/products/ryuic-a000017';},
          500 
        );
      });

      linknov = $('#nov > .mainImg > figure.pointer') 
      linknov.on('click', function(){ location.href = ''; });
      $(function () {
        $(linknov).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '';},
          500 
        );
      });

      linkdec = $('#dec > .mainImg > figure.pointer') 
      linkdec.on('click', function(){ location.href = ''; });
      $(function () {
        $(linkdec).longpress(function (e) {
          return false;
        },
          function () {
              location.href = '';},
          500 
        );
      });

    });
  /***** /timer *****/

  /***** zoom *****/
    $(document).ready(function(){
      $('.mainImg > figure > a').zoom();
      $('.mainImg > figure').zoom();
    });
  /***** /zoom *****/
/********** /12Tshirts **********/